// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// i18n
import './locales/i18n';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// devextreme
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

// redux
import store from './app/store';
import { Provider } from 'react-redux';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
import ThemeLocalization from './locales';
import 'src/App.css';

// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { AccessLevelProvider } from './auth/context/access-level-context';
import { CurrentPageProvider } from './layouts/dashboard/contexts/useCurrentPageContext';
import AccessLevelConsumer from './auth/hooks/AccessLevelConsumer';
import { MatrizFileProvider } from './sections/matriz/context/FilesContext';
import { ProductoFileProvider } from './sections/producto/context/FilesContext';
// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <Provider store={store}>
      <AuthProvider>
        <AccessLevelProvider>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'light', // 'light' | 'dark'
              themeDirection: 'ltr', //  'rtl' | 'ltr'
              themeContrast: 'default', // 'default' | 'bold'
              themeLayout: 'mini', // 'vertical' | 'horizontal' | 'mini'
              themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
              themeStretch: false,
            }}
          >
            <ThemeProvider>
              <CurrentPageProvider>
                <MatrizFileProvider>
                  <ProductoFileProvider>
                    <MotionLazy>
                      <SettingsDrawer />
                      <ProgressBar />
                      <AuthConsumer>
                        <AccessLevelConsumer>
                          <ThemeLocalization>
                            <Router />
                          </ThemeLocalization>
                        </AccessLevelConsumer>
                      </AuthConsumer>
                    </MotionLazy>
                  </ProductoFileProvider>
                </MatrizFileProvider>
              </CurrentPageProvider>
            </ThemeProvider>
          </SettingsProvider>
        </AccessLevelProvider>
      </AuthProvider>
    </Provider>
  );
}
